import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { setInterval, clearInterval } from 'timers';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component
export class ProductTimerComponent extends Vue {
    @Prop()
    text: string;

    @Prop()
    time: number;

    timer = 0;
    timerInterval: NodeJS.Timeout;

    get timerText() {
        const seconds = this.timer % 60;
        const minutes = (this.timer - seconds) / 60;
        return `${minutes}:${seconds.toString().padStart(2, '0')}`;
    }

    @Watch('time')
    watchForTime() {
        this.stopTimer();
        this.startTimer();
    }

    mounted() {
        this.startTimer();
    }

    destroyed() {
        this.stopTimer();
    }

    startTimer() {
        this.timer = this.time * 60;
        this.timerInterval = setInterval(() => {
            this.timer--;

            if (this.timer === 0 && this.timerInterval) {
                clearInterval(this.timerInterval);
            }
        }, 1000);
    }

    stopTimer() {
        if (this.timerInterval) {
            clearInterval(this.timerInterval);
        }
    }
}
